<template>
  <BaseDetailLayout :title="`View Ticket`">
    <template #action>
      <v-row>
        <v-col cols="12" class="text-right">
          <PrimaryButton
            id="supportInvalid"
            v-if="
              userDetails &&
              userDetails.role &&
              ['system_admin', 'support_user'].includes(userDetails.role) &&
              ticketDetails &&
              !ticketDetails.is_already_invalidate &&
              !ticketDetails.is_already_acknowledged
            "
            btnClass="mr-2 rounded-lg"
            icon=""
            iconClass=""
            name="Invalid"
            @click="openInvalidTicketDialog = true"
          >
          </PrimaryButton>

          <PrimaryButton
            id="supportAcknowledgement"
            v-if="
              userDetails &&
              userDetails.role &&
              ['system_admin', 'support_user'].includes(userDetails.role) &&
              ticketDetails &&
              !ticketDetails.is_already_invalidate &&
              !ticketDetails.is_already_acknowledged
            "
            btnClass="mr-2 rounded-lg"
            icon=""
            iconClass=""
            name="Acknowledgement"
            @click="openAcknowledgementDialog = true"
          >
          </PrimaryButton>

          <PrimaryButton
            id="supportResolutionDate"
            v-if="
              userDetails &&
              userDetails.role &&
              ['system_admin', 'support_user'].includes(userDetails.role) &&
              ticketDetails &&
              ticketDetails.is_already_acknowledged &&
              !ticketDetails.is_resolved
            "
            btnClass="mr-2 rounded-lg"
            icon=""
            iconClass=""
            name="  Resolution Date"
            @click="openResolutionDateDialog = true"
          >
          </PrimaryButton>
        </v-col>
      </v-row>
    </template>
    <template #detail>
      <div class="px-3 main-drivers-layout">
        <div class="support-column-grid pt-4">
          <div class="d-flex flex-column">
            <v-card
              class="mb-2"
              elevation="0"
              v-if="ticketDetails && ticketDetails.basic_details"
            >
              <v-card-title class="px-3 py-1">
                <v-row no-gutters>
                  <v-col cols="6">
                    <h6>Basic Details</h6>
                  </v-col>
                  <v-col cols="6" class="text-right">
                    <v-tooltip right>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          color="error"
                          @click="openRemarksDialog"
                          v-if="ticketDetails && ticketDetails.remarks"
                        >
                          mdi-information
                        </v-icon>
                      </template>
                      <span class="w-80"> Remarks </span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-subtitle
                style="height: calc(100vh - 520px)"
                class="overflow-y-auto custom-small-scroll"
              >
                <v-row no-gutters class="px-2">
                  <v-col cols="12">
                    <h5 class="text-capitalize text-caption">Title</h5>
                    <h5
                      class="font-weight-black"
                      v-if="ticketDetails.basic_details.title"
                    >
                      {{ ticketDetails.basic_details.title }}
                    </h5>
                  </v-col>
                  <v-col cols="12" class="pt-3">
                    <h5 class="text-capitalize text-caption">Description</h5>
                    <p
                      style="white-space: pre-line"
                      class="font-weight-black"
                      v-if="ticketDetails.basic_details.description"
                    >
                      {{ ticketDetails.basic_details.description }}
                    </p>
                  </v-col>
                </v-row>
              </v-card-subtitle>
            </v-card>
            <v-card
              class="card-box-shadow my-2 overflow-y-auto app-relative custom-small-scroll"
              style="height: 300px"
              elevation="0"
            >
              <v-card-title
                class="px-3 py-1 sticky-top white d-flex flex-column"
              >
                <v-row no-gutters class="w-100">
                  <v-col cols="6">
                    <h6>Other Details</h6>
                  </v-col>
                  <v-col cols="6" class="text-right"> </v-col>
                </v-row>
                <v-divider class="w-100"></v-divider>
              </v-card-title>

              <v-card-subtitle class="pt-4">
                <div v-if="ticketDetails && ticketDetails.other_details">
                  <div
                    v-for="(value, key, index) in ticketDetails.other_details"
                    :key="index"
                  >
                    <v-row
                      no-gutters
                      class="pt-1 px-2"
                      v-if="
                        ![
                          'verbose_impact',
                          'verbose_priority',
                          'verbose_category',
                          'verbose_module',
                          'verbose_status',
                        ].includes(key) && value
                      "
                    >
                      <v-col cols="5" v-if="key">
                        <h5 class="text-capitalize text-caption">
                          {{ key.replace(/_/g, "  ") }}
                        </h5>
                      </v-col>
                      <v-col cols="7" v-if="key == 'status'">
                        <v-chip
                          label
                          depressed
                          class="text-capitalize"
                          x-small
                          :color="getSupportStatusColorClass(value)"
                        >
                          {{ value.replaceAll("_", " ") }}
                        </v-chip>
                      </v-col>
                      <v-col cols="7" v-else-if="key == 'priority'">
                        <v-chip
                          label
                          class="text-capitalize"
                          depressed
                          x-small
                          :class="getSupportPriorityClass(value)"
                        >
                          {{ value }}
                        </v-chip>
                      </v-col>
                      <v-col cols="7" v-else>
                        <h5 class="text_color--text">{{ value }}</h5>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </v-card-subtitle>
            </v-card>
          </div>
          <v-card
            class="px-0 mx-2"
            elevation="0"
            style="height: calc(100vh - 160px)"
          >
            <v-card-title class="px-3 py-1">
              <v-row no-gutters>
                <v-col cols="6">
                  <h6>Comments</h6>
                </v-col>
              </v-row>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="d-flex flex-column">
              <div
                id="comment-target"
                class="overflow-y-auto custom-small-scroll"
                style="height: calc(100vh - 400px)"
              >
                <div v-scroll:#comment-target="onCommentScroll">
                  <div
                    v-for="(chat, index) in commentList"
                    :key="index"
                    class="d-flex py-2 px-8"
                    :class="!chat.set_right ? 'justify-start' : 'justify-end'"
                  >
                    <div
                      class="w-80 background_color pa-4 rounded-lg"
                      style="display: grid; grid-template-columns: 50px 1fr"
                    >
                      <div>
                        <v-btn
                          depressed
                          class="mr-1"
                          fab
                          dark
                          x-small
                          :color="!chat.set_right ? 'cyan' : 'warning'"
                        >
                          {{ chat.user.slice(0, 2) }}
                        </v-btn>
                      </div>
                      <div>
                        <div class="d-flex justify-space-between pr-2">
                          <h5 class="font-weight-black mr-2">
                            {{ chat.user }}
                          </h5>
                          <h5 class="font-weight-light">{{ chat.created }}</h5>
                        </div>

                        <div
                          class="d-flex flex-column text-right"
                          v-if="chat.attachment"
                        >
                          <a :href="chat.attachment">
                            <img
                              :src="chat.attachment"
                              contain
                              width="50"
                              height="50"
                            />
                          </a>
                        </div>
                        <div class="d-flex pt-2" v-else>
                          {{ chat.comment }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="px-4 pt-4">
                <v-row no-gutters>
                  <v-col cols="1">
                    <v-btn
                      depressed
                      class="mr-1"
                      fab
                      dark
                      v-if="userDetails && userDetails.username"
                      x-small
                      color="warning"
                    >
                      {{ userDetails.username.slice(0, 2) }}
                    </v-btn>
                  </v-col>
                  <v-col cols="11">
                    <v-form ref="commentForm" v-model="isValid">
                      <v-textarea
                        id="comment"
                        name="comment"
                        height="100"
                        outlined
                        background-color="background_color"
                        hide-details="auto"
                        label="Comment here..."
                        v-model="newComment"
                      ></v-textarea>
                    </v-form>
                  </v-col>
                  <v-col cols="12" class="text-right pt-3 pr-1">
                    <v-file-input
                      append-icon="mdi-paperclip"
                      prepend-icon=""
                      ref="fileUpload"
                      v-model="uploadFiles"
                      label="File input"
                      @change="sendMessage"
                      class="mr-2 d-none"
                      outlined
                      dense
                    >
                    </v-file-input>

                    <v-icon
                      color="primary"
                      class="mr-4"
                      @click="$refs.fileUpload.$refs.input.click()"
                      >mdi-paperclip</v-icon
                    >
                    <v-btn
                      color="primary"
                      small
                      :disabled="newComment == null || newComment == ''"
                      depressed
                      @click="sendMessage"
                    >
                      send
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
            </v-card-text>
          </v-card>
          <div class="d-flex flex-column">
            <v-card class="mb-3 rounded-lg" elevation="0">
              <v-card-title class="px-3 py-1">
                <v-row no-gutters>
                  <v-col cols="6">
                    <h6>Logs</h6>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text
                class="overflow-y-auto"
                style="height: calc(100vh - 530px)"
              >
                <Logs :logs="logs" />
              </v-card-text>
            </v-card>

            <v-card class="mt-1 h-100" elevation="0" style="height: 310px">
              <v-card-title class="px-3 py-1">
                <v-row no-gutters>
                  <v-col cols="6">
                    <h6>Attachments</h6>
                  </v-col>
                  <v-col cols="6" class="text-right">
                    <v-btn-toggle
                      dense
                      v-if="ticketDocumentList.length != 0"
                      v-model="toggleView"
                      class="pa-1 position-absolute"
                      tile
                      color="deep-purple accent-3"
                      group
                    >
                      <v-btn>
                        <v-icon color="primary">mdi-image</v-icon>
                      </v-btn>
                      <v-btn>
                        <v-icon color="primary">mdi-table</v-icon>
                      </v-btn>
                    </v-btn-toggle>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-divider></v-divider>

              <v-card-subtitle
                class="d-flex justify-center align-center"
                v-if="ticketDocumentList.length == 0"
              >
                <h5 class="text-caption font-weight-bold">
                  There is no document available.
                </h5>
              </v-card-subtitle>
              <v-card-subtitle
                style="height: 250px"
                class="overflow-y-auto"
                v-else
              >
                <v-row no-gutters v-if="toggleView == 0">
                  <v-col
                    cols="3"
                    class="pa-1"
                    v-for="(document, index) in ticketDocumentList"
                    :key="index"
                  >
                    <v-card elevation="0" class="pa-1" outlined>
                      <a
                        :href="document.attachment"
                        target="_blank"
                        style="text-decoration: none"
                      >
                        <v-img :src="document.attachment" height="50"></v-img>
                      </a>
                    </v-card>
                  </v-col>
                </v-row>
                <div v-else>
                  <v-row
                    no-gutters
                    class="mb-2"
                    v-for="(document, index) in ticketDocumentList"
                    :key="index"
                  >
                    <v-col cols="10">
                      <h5 class="ma-0" v-if="document.attachment">
                        {{ document.name }}
                      </h5>
                    </v-col>
                    <v-col cols="2" class="text-right">
                      <a
                        :href="document.attachment"
                        target="_blank"
                        style="text-decoration: none"
                      >
                        <v-icon small color="secondary darken-2" class="mr-2">
                          mdi-eye
                        </v-icon>
                      </a>
                    </v-col>
                  </v-row>
                </div>
              </v-card-subtitle>
            </v-card>
          </div>
        </div>
      </div>
    </template>
    <template #dialog>
      <AcknowledgementForm
        :id="$route.params.id"
        v-model="openAcknowledgementDialog"
        @getList="getSupportUserTicketView"
      />
      <TicketResolutionDateForm
        :id="$route.params.id"
        v-model="openResolutionDateDialog"
        @getList="getSupportUserTicketView"
      />
      <InvalidTicket
        :id="$route.params.id"
        v-model="openInvalidTicketDialog"
        @getList="getSupportUserTicketView"
      />
    </template>
  </BaseDetailLayout>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import { bus } from "@/main.js";
import BaseDetailLayout from "@/components/LayoutComponents/BaseDetailLayout.vue";
import DialogBase from "@/components/BaseComponents/DialogBase.vue";
import Logs from "@/components/BaseComponents/Logs.vue";
import BaseSmallTripDetail from "@/components/BaseComponents/BaseSmallTripDetail.vue";
import BaseTooltip from "@/components/BaseComponents/BaseTooltip.vue";
import {
  generatedFormData,
  getSupportStatusColorClass,
  getSupportPriorityClass,
} from "@/utils/functions";
import AcknowledgementForm from "@/components/ModuleBasedComponents/SupportUser/AcknowledgementForm.vue";
import InvalidTicket from "@/components/ModuleBasedComponents/SupportUser/InvalidTicket.vue";
import TicketResolutionDateForm from "../SupportUser/TicketResolutionDateForm.vue";
import { supportModule } from "@/utils/moduleMapping";

export default {
  components: {
    BaseDetailLayout,
    DialogBase,
    Logs,
    BaseSmallTripDetail,
    BaseTooltip,
    AcknowledgementForm,
    InvalidTicket,
    TicketResolutionDateForm,
  },
  data() {
    return {
      supportModule,
      getSupportStatusColorClass,
      getSupportPriorityClass,
      isValid: true,
      logs: [],
      ticketDocumentList: [],
      ticketDetails: {},
      commentList: [],
      ticketID: null,
      newComment: null,
      uploadFiles: null,
      totalCount: 0,
      userDetails: this.$helper.getUserDetailsLocalStorage(),
      toggleView: 0,
      openResolutionDateDialog: false,
      openAcknowledgementDialog: false,
      openInvalidTicketDialog: false,
    };
  },
  computed: {
    context() {
      return { parentComponent: this };
    },
  },
  methods: {
    openRemarksDialog() {
      this.$root.$confirm("Remarks", `${this.ticketDetails.remarks}`, {
        color: "error",
        hasActions: false,
      });
    },
    autoScroll() {
      setTimeout(() => {
        if (document.getElementById("comment-target")) {
          let element = document.getElementById("comment-target");
          element.scrollTop = element.scrollHeight;
        }
      }, 200);
    },
    setScrolling() {
      let element = document.getElementById("comment-target");
      element.scrollTop = element.clientHeight;
    },
    onCommentScroll(e) {
      let scroll = parseInt(e.target.scrollTop);
      if (scroll == 0 && this.totalCount != this.commentList.length) {
        if (
          (this.userDetails && this.userDetails.role == "support_user") ||
          this.userDetails.role == "system_admin"
        ) {
          this.getSupportUserTicketCommentList();
        } else {
          this.getTicketCommentList();
        }
      }
    },
    getTicketView() {
      bus.$emit("showLoader", true);
      this.$api.support
        .getTicketView(this.ticketID)
        .then((res) => {
          this.ticketDetails = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
    getTicketAttachmentList() {
      bus.$emit("showLoader", true);
      this.$api.support
        .getTicketAttachmentList({ ticket: this.ticketID, limit: "all" })
        .then((res) => {
          this.ticketDocumentList = res.data.map((v) => {
            v.name = v.attachment
              .slice(v.attachment.lastIndexOf("/"))
              .replace("/", "");
            return v;
          });
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
    getSupportLogs() {
      bus.$emit("showLoader", true);
      this.$api.support
        .getSupportLogs({ ticket: this.ticketID })
        .then((res) => {
          this.logs = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
    getTicketCommentList(reload, params = {}) {
      params = {
        ...params,
        offset: reload ? 0 : this.commentList.length,
        limit: 10,
        ticket: this.ticketID,
      };
      bus.$emit("showLoader", true);
      this.$api.support
        .getTicketCommentList(params)
        .then((res) => {
          let responseComment = res.data.reverse();
          if (reload) {
            this.commentList = responseComment;
            this.autoScroll();
          } else {
            this.commentList = [...responseComment, ...this.commentList];
            this.setScrolling();
          }
          this.totalCount = res.count;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
    getSupportUserTicketView() {
      bus.$emit("showLoader", true);
      this.$api.supportUserTicket
        .getTicketView(this.ticketID)
        .then((res) => {
          this.ticketDetails = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
    sendMessage() {
      if (this.newComment || this.uploadFiles) {
        let payload = {
          ticket: this.ticketID,
          comment: this.newComment,
          attachment: this.uploadFiles,
        };
        bus.$emit("showLoader", true);
        this.$api.support
          .sendComment(generatedFormData(payload))
          .then((res) => {
            this.newComment = null;
            this.getTicketCommentList(true);
            this.uploadFiles = null;
            this.$refs.fileUpload.blur();
            bus.$emit("showLoader", false);
          })
          .catch((err) => {
            console.log(err);
            bus.$emit("showLoader", false);
          });
      } else {
        bus.$emit("showToastMessage", {
          message: "Please Enter The Message",
          color: "error",
        });
      }
    },
  },
  mounted() {
    if (
      "id" in this.$route.params &&
      (this.userDetails.role == "support_user" ||
        this.userDetails.role == "system_admin")
    ) {
      this.ticketID = this.$route.params.id;
      this.getSupportUserTicketView();
      this.getTicketAttachmentList();
      this.getTicketCommentList(true);
      this.getSupportLogs();
    } else {
      this.ticketID = this.$route.params.id;
      this.getTicketView();
      this.getTicketAttachmentList();
      this.getTicketCommentList(true);
      this.getSupportLogs();
    }
  },
};
</script>

<style scoped>
.main-drivers-layout {
  height: 100%;
}
.main-drivers-layout .support-column-grid {
  display: grid;
  grid-template-columns: 400px 1fr 400px;
  grid-column-gap: 8px;
  height: calc(100vh - 130px);
}

.card-vehicle-analytic-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  column-gap: 9px;
}
.w-80 {
  max-width: 80% !important;
  width: auto !important;
}
</style>
